<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @todoMatchQuestionnaireUser="handleTodoMatchQuestionnaireUser"
        @todoRelateAppUser="handleTodoRelateAppUser"
        @todoRelateStoreArchives="handleTodoRelateStoreArchives"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.provinceName"
              placeholder="请输入省区名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.groupName"
              placeholder="请输入微信群名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.nickname"
              placeholder="请输入成员昵称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.storeName"
              placeholder="请输入门店名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.phone"
              placeholder="请输入联系电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col style="width: 140px;">
            <el-checkbox
              v-model="masterList.tableQuery.queryAtMoreGroup"
              :true-label="1"
              :false-label="2"
              style="margin-top:5px;"
            >
              重复入群的成员
            </el-checkbox>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @connectStore="handleConnectStore(arguments)"
        @cancelConnectStore="handleCancelConnectStore(arguments)"
        @connectAppUser="handleConnectAppUser(arguments)"
        @cancelConnectAppUser="handleCancelConnectAppUser(arguments)"
        @cancelMatchQuestionnaireUser="handleCancelMatchQuestionnaireUser(arguments)"
        @view="handleView(arguments)"
        @dblclick="handleView(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 待匹配问卷用户列表 -->
    <todo-match-contact-dialog
      :dialog-visible.sync="dialogTodoMatchQuestionnaireUserVisible"
      @reloadData="loadTableData()"
    />

    <!-- 可关联小程序用户的微信成员列表 -->
    <able-relate-app-user-dialog
      :dialog-visible.sync="dialogAbleRelateAppUserVisible"
      @reloadData="loadTableData()"
    />

    <!-- 可关联零售户档案的微信成员列表 -->
    <able-relate-store-dialog
      :dialog-visible.sync="dialogAbleRelateStoreVisible"
      @reloadData="loadTableData()"
    />

    <!-- 零售户认证 -->
    <connect-store-dialog
      :data-id="id"
      :dialog-visible.sync="dialogConnectStoreVisible"
      @reloadData="loadTableData()"
    />

    <!-- 关联小程序用户 -->
    <connect-app-user-dialog
      :data-id="id"
      :dialog-visible.sync="dialogConnectAppUserVisible"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogViewVisible"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 权限检测
import checkPermission from '@/utils/permission'
// 待匹配问卷用户列表
import todoMatchContactDialog from './components/todoMatchContactDialog'
// 可关联小程序用户的微信成员列表
import ableRelateAppUserDialog from './components/ableRelateAppUserDialog'
// 可关联零售户档案的微信成员列表
import ableRelateStoreDialog from './components/ableRelateStoreDialog'
// 零售户认证
import connectStoreDialog from './components/connectStoreDialog'
// 关联小程序用户
import connectAppUserDialog from './components/connectAppUserDialog'
// 查看
import viewDialog from './components/viewDialog'
// 微信群成员管理API
import { loadWeChatContactListDataApi, exportWeChatContactListDataApi, countToMatchContactApi, countAbleRelateContactApi, cancelMatchQuestionnaireUserApi, cancelConnectStoreWeChatContactApi, cancelConnectAppUserWeChatContactApi } from '@/api/v2/weChatContact'

export default {
  name: 'WeChatGroupMemberView',
  components: { CustomTable2, TableOperation2, todoMatchContactDialog, ableRelateAppUserDialog, ableRelateStoreDialog, connectStoreDialog, connectAppUserDialog, viewDialog },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'chat_room_member_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['chat_room_member_edit'],
            prop: 'connectStore',
            label: '零售户认证',
            method: 'connectStore'
          },
          {
            permissionSigns: ['chat_room_member_edit'],
            prop: 'cancelConnectStore',
            label: '取消零售户认证',
            method: 'cancelConnectStore'
          },
          {
            permissionSigns: ['chat_room_member_edit'],
            prop: 'connectAppUser',
            label: '关联小程序用户',
            method: 'connectAppUser'
          },
          {
            permissionSigns: ['chat_room_member_edit'],
            prop: 'cancelConnectAppUser',
            label: '取消关联小程序用户',
            method: 'cancelConnectAppUser'
          },
          {
            permissionSigns: ['chat_room_member_edit'],
            prop: 'cancelMatchQuestionnaireUser',
            label: '取消匹配问卷用户',
            method: 'cancelMatchQuestionnaireUser'
          },
          {
            permissionSigns: ['chat_room_member_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['chat_room_member_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 20,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          provinceName: '',
          groupName: '',
          nickname: '',
          storeName: '',
          phone: '',
          queryAtMoreGroup: 2,
        },
      },
      // 待办
      todoList: [
        { permissionSigns: ['chat_room_member_edit'], label: '待匹配问卷用户的群成员', method: 'todoMatchQuestionnaireUser', count: 0 },
        { permissionSigns: ['chat_room_member_edit'], label: '可关联睿零售用户的群成员', method: 'todoRelateAppUser', count: 0 },
        { permissionSigns: ['chat_room_member_edit'], label: '可关联零售户档案的群成员', method: 'todoRelateStoreArchives', count: 0 },
      ],
      id: null,
      dialogTodoMatchQuestionnaireUserVisible: false,
      dialogAbleRelateAppUserVisible: false,
      dialogAbleRelateStoreVisible: false,
      dialogConnectStoreVisible: false,
      dialogConnectAppUserVisible: false,
      dialogViewVisible: false,
      dialogTitle: '',
      eventType: '',
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80, align: 'center' },
      { prop: 'smallHeadImgUrlArray', label: '头像', filterColumn: 'twcc.small_head_img_url', width: 100, isImage: true },
      { prop: 'typeValue', label: '成员类别', filterColumn: "(case twcc.type when 1 then '中烟工作人员' when 2 then '运维工作人员' when 3 then '零售户' when 9 then '其他' else '' end)", width: 110 },
      { prop: 'userName', label: '成员微信号', filterColumn: 'twcc.user_name', width: 150 },
      { prop: 'nickname', label: '成员昵称', filterColumn: 'twcc.nickname', width: 150 },
      { prop: 'questionnaireMatchTime', label: '问卷用户匹配时间', filterColumn: 'twcc.questionnaire_match_time', width: 150, isBetween: true },
      { prop: 'questionnaireUid', label: '腾讯问卷用户ID', filterColumn: "ifnull(tqu.uid, '')", width: 160 },
      { prop: 'questionnaireCertificateNo', label: '问卷填写专卖证号', filterColumn: "ifnull(tqu.certificate_no, '')", width: 150 },
      { prop: 'questionnaireStoreName', label: '问卷填写门店名称', filterColumn: "ifnull(tqu.store_name, '')", width: 150 },
      { prop: 'questionnaireStoreLevel', label: '问卷填写门店档位', filterColumn: "ifnull(tqu.level, '')", width: 150 },
      { prop: 'certificatedStoreName', label: '零售户名称', filterColumn: "ifnull(tsi.store_name, '')", width: 150 },
      { prop: 'storeCertificateNo', label: '专卖证号', filterColumn: "ifnull(tsi.certificate_no, '')", width: 150 },
      { prop: 'storeCity', label: '零售户城市', filterColumn: "ifnull(tsi.city_name, '')", width: 120 },
      { prop: 'storeCounty', label: '零售户区县', filterColumn: "ifnull(tsi.county_name, '')", width: 120 },
      { prop: 'storeAddress', label: '零售户地址', filterColumn: "ifnull(tsi.address, '')", width: 150 },
      { prop: 'storeLevel', label: '零售户档位', filterColumn: "ifnull(tsi.level_str, '')", width: 120 },
      { prop: 'storeStatusValue', label: '零售户维护状态', filterColumn: "ifnull(tsi.status, 0)", filterValue: 'storeStatus', filterArray: [{ label: '维护中', value: 1 }, { label: '停止维护', value: 2 }], width: 140 },
      { prop: 'wxOpenId', label: '睿零售注册用户ID', filterColumn: "ifnull(tau.wx_open_id, '')", width: 180 },
      { prop: 'appUserName', label: '睿零售用户姓名', filterColumn: "ifnull(tau.name, '')", width: 140 },
      { prop: 'appUserPhone', label: '睿零售用户电话', filterColumn: "ifnull(tau.phone, '')", width: 140 },
      { prop: 'provinceName', label: '所在省区', filterColumn: "ifnull(crg.province_name, '')", width: 150 },
      { prop: 'groupNames', label: '所在微信群', filterColumn: "ifnull(crg.group_names, '')", width: 300 },
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadWeChatContactListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
      _this.loadTodoCount();
    },
    // 获取待办任务数量
    loadTodoCount () {
      let _this = this;
      if (checkPermission(['chat_room_member_edit'])) {
        // 待匹配问卷用户的群成员数量
        countToMatchContactApi({}).then(response => {
          _this.todoList[0].count = response.data || 0;
        })
        // 可关联睿零售用户的群成员数量
        countAbleRelateContactApi({ todoType: 1 }).then(response => {
          _this.todoList[1].count = response.data || 0;
        })
        // 可关联零售户档案的群成员数量
        countAbleRelateContactApi({ todoType: 2 }).then(response => {
          _this.todoList[2].count = response.data || 0;
        })
      }
    },
    // 打开待匹配问卷用户的群成员列表弹窗
    handleTodoMatchQuestionnaireUser () {
      let _this = this;
      _this.dialogTodoMatchQuestionnaireUserVisible = !_this.dialogTodoMatchQuestionnaireUserVisible;
    },
    // 打开可关联睿零售用户的群成员列表弹窗
    handleTodoRelateAppUser () {
      let _this = this;
      _this.dialogAbleRelateAppUserVisible = !_this.dialogAbleRelateAppUserVisible;
    },
    // 打开可关联零售户档案的群成员列表弹窗
    handleTodoRelateStoreArchives () {
      let _this = this;
      _this.dialogAbleRelateStoreVisible = !_this.dialogAbleRelateStoreVisible;
    },
    // 关联零售户
    handleConnectStore (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要认证零售户档案的微信群成员', type: 'warning' })
        return
      }
      if (args[0].type !== 3) {
        _this.$message({ message: '微信群成员类型不是零售户，不能操作', type: 'warning' })
        return
      }

      _this.id = args[0].id
      _this.dialogConnectStoreVisible = !_this.dialogConnectStoreVisible
    },
    // 取消零售户认证
    handleCancelConnectStore (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要取消认证零售户档案的微信群成员', type: 'warning' })
        return
      }
      if (args[0].type !== 3) {
        _this.$message({ message: '微信群成员类型不是零售户，不能操作', type: 'warning' })
        return
      }
      if (!args[0].storeId) {
        _this.$message({ message: '微信群成员没有认证零售户档案，不能操作', type: 'warning' })
        return
      }

      _this.$confirm('是否确认取消该微信群成员认证的零售户档案?', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        cancelConnectStoreWeChatContactApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '取消认证零售户档案成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 关联小程序用户
    handleConnectAppUser (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要关联小程序注册用户的微信群成员', type: 'warning' })
        return
      }
      if (args[0].type !== 3) {
        _this.$message({ message: '微信群成员类型不是零售户，不能操作', type: 'warning' })
        return
      }

      _this.id = args[0].id
      _this.dialogConnectAppUserVisible = !_this.dialogConnectAppUserVisible
    },
    // 取消关联小程序用户
    handleCancelConnectAppUser (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要取消关联小程序注册用户的微信群成员', type: 'warning' })
        return
      }
      if (args[0].type !== 3) {
        _this.$message({ message: '微信群成员类型不是零售户，不能操作', type: 'warning' })
        return
      }
      if (!args[0].appUserId) {
        _this.$message({ message: '微信群成员没有关联小程序注册用户，不能操作', type: 'warning' })
        return
      }

      _this.$confirm('是否确认取消该微信群成员关联的小程序用户?', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        cancelConnectAppUserWeChatContactApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '取消关联小程序用户成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 取消匹配问卷用户
    handleCancelMatchQuestionnaireUser (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要取消匹配问卷用户的微信群成员', type: 'warning' })
        return
      }
      if (args[0].type !== 3) {
        _this.$message({ message: '微信群成员类型不是零售户，不能操作', type: 'warning' })
        return
      }
      if (!args[0].questionnaireUserId) {
        _this.$message({ message: '微信群成员没有匹配问卷用户，不能操作', type: 'warning' })
        return
      }

      _this.$confirm('是否确认取消该微信群成员匹配问卷用户?', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        cancelMatchQuestionnaireUserApi({ id: args[0].id }).then(() => {
          _this.$message({ message: '取消匹配问卷用户成功', type: 'success' })
          _this.loadTableData()
        })
      })
    },
    // 查看
    handleView (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的微信群成员', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogTitle = '查看微信群成员信息'
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportWeChatContactListDataApi(_this.exportObj).then((response) => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
